/*
 * A partir de una lista de persons o places genera un array de palabras que sera utilizado
 * para generar un listado de chips.
 * Esta funcionalidad es para agregar filtros en Persons y Places
 */
export default {
	methods: {
		labelSelected(labels) {
			return labels.some(
				label => label != 'caducado' && label != 'pendiente' && label != 'subido'
			);
		},
		labelDefaultSelected(labels) {
			return (
				labels.includes('caducado') ||
				labels.includes('pendiente') ||
				labels.includes('subido')
			);
		},
		formatText(word) {
			word = word.replace(/[^A-Z.a-z]/g, '').toLowerCase();
			return word;
		},
		addLabels(listWord) {
			let listWordCount = [];
			listWord.forEach(word => {
				if (listWordCount.length) {
					let wordFound = false;
					for (let index = 0; index < listWordCount.length; index++) {
						if (listWordCount[index].tag === word) {
							listWordCount[index].count++;
							wordFound = true;
							break;
						}
					}
					if (!wordFound) listWordCount.push({ tag: word, count: 1 });
				} else listWordCount.push({ tag: word, count: 1 });
			});
			listWord = [];
			listWordCount.forEach(word => {
				if (word.count > 2) {
					listWord.push(word.tag);
				}
			});
			return listWord;
		},
		addDefaultLabels(label) {
			if (label.length) {
				label.push('pendiente');
				label.push('subido');
				label.push('caducado');
			}
			return label;
		},
		getLabelsPersons(persons) {
			let labels = [];
			persons.forEach(person =>
				person.typeDocument.forEach(typeDocument => {
					if (typeDocument) {
						let words = typeDocument.type.split(' ');
						words.forEach(word => {
							word = this.formatText(word);
							if (word.length > 2) labels.push(word);
						});
					}
				})
			);
			labels = this.addLabels(labels);
			labels = this.addDefaultLabels(labels);
			labels.reverse();
			return labels;
		},
		getLabelsPlaces(places) {
			let labels = [];
			places.forEach(place =>
				place.typeDocuments.forEach(typeDocument => {
					if (typeDocument) {
						let words = typeDocument.text.split(' ');
						words.forEach(word => {
							word = this.formatText(word);
							if (word.length > 2) labels.push(word);
						});
					}
				})
			);
			labels = this.addLabels(labels);
			labels = this.addDefaultLabels(labels);
			labels.reverse();
			return labels;
		},
	},
};
